import {
  TypedUseSelectorHook,
  useSelector as useReduxSelector
} from "react-redux";
import { AppState } from "redux/types";

export const useSelector: TypedUseSelectorHook<AppState> = useReduxSelector;
